const art = (props) => {
    return (
        <svg
            width="190px"
            height="122px"
            viewBox="0 0 263 170"
        >
            <g
                id="3"
                stroke="none"
                strokeWidth="1"
                fill="none"
                fillRule="evenodd"
            >
                <g
                    id="empty"
                    transform="translate(0.000000, 0.785104)"
                >
                    <path
                        d="M0.00925615907,0 L260.631876,0.399782376 L260.563421,15.7758021 L0.0551405048,15.7758021 C0.0336844646,10.5172645 -0.0218597434,5.25853767 0.00925615907,0 Z"
                        id="e_header"
                        fill="#CAE4FE"
                    ></path>
                    <g
                        id="e4"
                        transform="translate(182.364045, 81.650834)"
                    >
                        <path
                            d="M0,0.383337248 C0.223263314,39.0604747 0.537392846,74.6144098 1.1882291,75.979637 C15.8169469,78.7696156 68.7862843,77.4363465 68.7813601,76.8309183 C68.7538587,73.4380344 68.9215616,7.77285113 68.8633069,0.60022241 L0,0.383337248 Z"
                            id="Fill-9-Copy"
                            fill="#FFFFFF"
                        ></path>
                        <path
                            d="M0,0.383337248 C0.223263314,39.0604747 0.537392846,74.6144098 1.1882291,75.979637 C15.8169469,78.7696156 68.7862843,77.4363465 68.7813601,76.8309183 C68.7538587,73.4380344 68.9215616,7.77285113 68.8633069,0.60022241 L0,0.383337248 Z"
                            id="Stroke-10-Copy"
                            stroke="#CAE4FE"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        ></path>
                        <path
                            d="M64.179621,3.53849767 C63.4056087,4.54410893 59.8572603,7.51774035 59.8181034,7.48213114 C59.5987493,7.28244024 56.0909833,4.17649614 55.5701597,3.6516093 L64.179621,3.53849767 Z"
                            id="Fill-14-Copy"
                            fill="#CAE4FE"
                        ></path>
                        <path
                            d="M47.016869,55.0377356 C73.1867367,33.4222186 32.5985199,0.641220461 14.8337883,28.3849769 C12.1826669,32.5252983 11.4241079,36.5326873 11.8521314,40.940087 C13.2087405,54.9084439 29.2320854,66.0204346 46.8248498,55.1814968 L47.016869,55.0377356 Z"
                            id="Fill-15-Copy"
                            fill="#FFFFFF"
                        ></path>
                        <path
                            d="M47.016869,55.0377356 C73.1867367,33.4222186 32.5985199,0.641220461 14.8337883,28.3849769 C12.1826669,32.5252983 11.4241079,36.5326873 11.8521314,40.940087 C13.2087405,54.9084439 29.2320854,66.0204346 46.8248498,55.1814968 L47.016869,55.0377356 Z"
                            id="Stroke-16-Copy"
                            stroke="#CAE4FE"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        ></path>
                        <path
                            d="M47.5011618,23.2582503 C54.128853,28.4234299 58.9010945,37.6541539 54.8727775,46.1331634 C53.0719192,45.7930777 51.3279973,45.2850013 49.5471184,44.8867112 C47.4437564,44.4615574 31.4273833,41.8305105 31.3071322,40.6709918 C31.7432065,39.4556939 33.4803748,37.7762526 34.3830082,36.8069245 C35.4761486,35.632948 36.848249,34.216173 37.9247868,33.1129933 C41.1200697,29.8384326 44.448079,26.6481006 47.5011618,23.2582503 Z"
                            id="Fill-17-Copy"
                            fill="#FFFFFF"
                        ></path>
                        <path
                            d="M47.5011618,23.2582503 C54.128853,28.4234299 58.9010945,37.6541539 54.8727775,46.1331634 C53.0719192,45.7930777 51.3279973,45.2850013 49.5471184,44.8867112 C47.4437564,44.4615574 31.4273833,41.8305105 31.3071322,40.6709918 C31.7432065,39.4556939 33.4803748,37.7762526 34.3830082,36.8069245 C35.4761486,35.632948 36.848249,34.216173 37.9247868,33.1129933 C41.1200697,29.8384326 44.448079,26.6481006 47.5011618,23.2582503 Z"
                            id="Stroke-18-Copy"
                            stroke="#CAE4FE"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        ></path>
                        <path
                            d="M46.6250854,22.4439983 C48.386326,23.8881678 47.7917717,23.318062 48.5260549,24.0378356 C42.3620319,28.8137083 36.8415092,34.2797722 31.4552467,39.8228426 L31.3071322,39.0886476 C31.3959097,36.5381937 31.7386238,31.8826839 32.0889943,29.3573749 C32.5843803,24.7672235 32.0703091,22.2878594 33.3855656,17.7367196 C38.5536214,17.7749917 42.6618156,19.73833 46.6250854,22.4439983 Z"
                            id="Fill-19-Copy"
                            fill="#FFFFFF"
                        ></path>
                        <path
                            d="M46.6250854,22.4439983 C48.386326,23.8881678 47.7917717,23.318062 48.5260549,24.0378356 C42.3620319,28.8137083 36.8415092,34.2797722 31.4552467,39.8228426 L31.3071322,39.0886476 C31.3959097,36.5381937 31.7386238,31.8826839 32.0889943,29.3573749 C32.5843803,24.7672235 32.0703091,22.2878594 33.3855656,17.7367196 C38.5536214,17.7749917 42.6618156,19.73833 46.6250854,22.4439983 Z"
                            id="Stroke-20-Copy"
                            stroke="#CAE4FE"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        ></path>
                    </g>
                    <g
                        id="e1"
                        transform="translate(9.392140, 22.768021)"
                    >
                        <path
                            d="M163.579766,52.2046271 C163.567117,25.9389319 163.297862,1.7955933 161.777389,0.876844041 C127.23107,-0.8271594 1.98898156,0.769449259 1.99260883,1.18059914 C2.01251226,3.48453528 0.741482593,48.085083 0.782678305,52.9558293 L163.579766,52.2046271 Z"
                            id="Fill-5-Copy"
                            fill="#FFFFFF"
                        ></path>
                        <path
                            d="M163.579766,52.2046271 C163.567117,25.9389319 163.297862,1.7955933 161.777389,0.876844041 C127.23107,-0.8271594 1.98898156,0.769449259 1.99260883,1.18059914 C2.01251226,3.48453528 0.741482593,48.085083 0.782678305,52.9558293 L163.579766,52.2046271 Z"
                            id="Stroke-6-Copy"
                            stroke="#CAE4FE"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        ></path>
                        <path
                            d="M14.0882095,11.9249808 C20.9496344,11.9472289 27.7589381,12.0402596 34.4378454,11.1499536"
                            id="Stroke-22-Copy"
                            stroke="#CAE4FE"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        ></path>
                        <path
                            d="M14.0882095,17.4639615 C46.9105625,17.3718034 79.898234,19.0378547 112.705676,19.0378547"
                            id="Stroke-23-Copy"
                            stroke="#CAE4FE"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        ></path>
                        <path
                            d="M14.0882095,24.6026411 C51.9241886,22.4650608 90.7587323,27.8545582 128.359242,23.7705953"
                            id="Stroke-24-Copy"
                            stroke="#CAE4FE"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        ></path>
                        <path
                            d="M14.0882095,31.6584964 C30.5151801,31.6784528 46.938029,32.0591229 63.3969427,32.0591229"
                            id="Stroke-25-Copy"
                            stroke="#CAE4FE"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        ></path>
                        <path
                            d="M14.0882095,39.5463974 C37.5893286,40.3431073 60.9922256,40.335186 84.5292569,40.3351876"
                            id="Stroke-26-Copy"
                            stroke="#CAE4FE"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        ></path>
                        <path
                            d="M158.101018,5.62842286 C157.327005,6.63403412 153.778657,9.60766554 153.7395,9.57205633 C153.520146,9.37236543 150.01238,6.26642133 149.491556,5.74153449 L158.101018,5.62842286 Z"
                            id="Fill-30-Copy"
                            fill="#CAE4FE"
                        ></path>
                    </g>
                    <g
                        id="e3"
                        transform="translate(10.174818, 81.650834)"
                    >
                        <path
                            d="M162.797087,0.897975129 C162.687621,39.4938476 162.329366,74.9718957 160.805482,76.32739 C126.252606,78.956449 1.01536988,77.0635378 1.02048514,76.4593773 C1.04894462,73.073735 -0.0577198628,7.54074091 0.00236125801,0.383337248 L162.797087,0.897975129 Z"
                            id="Fill-11-Copy"
                            fill="#FFFFFF"
                        ></path>
                        <path
                            d="M162.797087,0.897975129 C162.687621,39.4938476 162.329366,74.9718957 160.805482,76.32739 C126.252606,78.956449 1.01536988,77.0635378 1.02048514,76.4593773 C1.04894462,73.073735 -0.0577198628,7.54074091 0.00236125801,0.383337248 L162.797087,0.897975129 Z"
                            id="Stroke-12-Copy"
                            stroke="#CAE4FE"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        ></path>
                        <path
                            d="M10.174818,13.003979 C11.1172018,19.1728577 10.9444562,63.6433032 11.972469,64.6665288 C106.632739,64.6665288 138.298402,65.5611225 145.578165,64.6665288"
                            id="Stroke-21-Copy"
                            stroke="#CAE4FE"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        ></path>
                        <path
                            d="M21.1323142,64.113816 C21.2816136,59.0152047 21.1779004,38.5642273 21.4401583,38.4654151 C22.0990526,38.2170546 36.9466021,38.0643709 37.7009711,38.6535382 C38.9447966,39.6247476 39.1339152,61.1812808 39.1339152,64.2753359"
                            id="Stroke-31-Copy"
                            stroke="#CAE4FE"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        ></path>
                        <path
                            d="M54.954458,65.064126 C54.954458,59.6877897 54.6249884,31.5607212 54.8916531,31.4322252 C55.5613855,31.1094666 70.6531591,30.9111233 71.4199366,31.6766904 C72.6842215,32.9389697 72.7890824,60.6521745 72.7890824,64.6733233"
                            id="Stroke-32-Copy"
                            stroke="#CAE4FE"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        ></path>
                        <path
                            d="M85.4657082,64.2753359 C86.545867,59.5069984 85.0803389,22.1865755 85.3444105,22.0297638 C86.0078615,21.6358499 100.958092,21.3939415 101.717678,22.3280264 C102.970105,23.8682487 103.313536,58.8822019 103.313536,63.788692"
                            id="Stroke-33-Copy"
                            stroke="#CAE4FE"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        ></path>
                        <path
                            d="M119.130818,63.6000303 C119.130818,58.3307366 118.807782,30.7636771 119.06924,30.6377394 C119.725894,30.3214069 134.522873,30.1270126 135.274769,30.8773373 C136.514366,32.1144847 136.129569,61.1230381 136.129569,65.064126"
                            id="Stroke-34-Copy"
                            stroke="#CAE4FE"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        ></path>
                    </g>
                    <g
                        id="e2"
                        transform="translate(182.364045, 22.768021)"
                    >
                        <path
                            d="M68.8756908,0.130224384 C68.7502422,26.6055728 68.5260143,50.9426318 67.8785134,51.8755461 C53.2549163,53.7489013 0.274786471,52.7041238 0.278224693,52.2896939 C0.29718138,49.9671926 -0.0367908379,5.0166407 0.00335273421,0.106892117 L68.8756908,0.130224384 Z"
                            id="Fill-7-Copy"
                            fill="#FFFFFF"
                        ></path>
                        <path
                            d="M68.8756908,0.130224384 C68.7502422,26.6055728 68.5260143,50.9426318 67.8785134,51.8755461 C53.2549163,53.7489013 0.274786471,52.7041238 0.278224693,52.2896939 C0.29718138,49.9671926 -0.0367908379,5.0166407 0.00335273421,0.106892117 L68.8756908,0.130224384 Z"
                            id="Stroke-8-Copy"
                            stroke="#CAE4FE"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        ></path>
                        <path
                            d="M10.174818,41.1239777 C19.9114652,22.2504876 27.0437231,39.0003747 34.5239299,34.6599044 C38.2268422,32.511291 40.5598851,22.2380778 45.9823735,23.0246681 C50.6876858,23.707207 50.7956508,32.0611017 57.9181946,29.6502596"
                            id="Stroke-28-Copy"
                            stroke="#CAE4FE"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        ></path>
                        <path
                            d="M64.179621,3.26205254 C63.4056087,4.26768566 59.8572603,7.24138172 59.8181034,7.20568445 C59.5987493,7.00607649 56.0909833,3.90006488 55.5701597,3.37507935 L64.179621,3.26205254 Z"
                            id="Fill-29-Copy"
                            fill="#CAE4FE"
                        ></path>
                        <path
                            d="M9.56658032,10.3611635 C9.56658032,13.202193 9.17408884,37.8310219 9.56658032,44.1935731 C9.59019999,44.5764639 51.761982,43.5502185 58.7008729,43.5502185"
                            id="Stroke-50-Copy-2"
                            stroke="#CAE4FE"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        ></path>
                    </g>
                </g>
                <path
                    d="M261.27023,1.18207505 C260.920995,85.2667774 260.187898,162.560265 257.743531,165.520133 C202.444819,171.401385 2.06584877,167.834749 2.07671015,166.518427 C2.13760814,159.14241 0.66213166,16.3782029 0.790611554,0.785104171 L261.27023,1.18207505 Z"
                    id="2"
                    fill="#EDF4FF"
                ></path>
                <path
                    d="M0.791929338,0.785104171 L261.27023,1.18946506 L261.201813,16.7415789 L0.837788276,16.7415789 C0.816344117,11.4229134 0.760830666,6.10396096 0.791929338,0.785104171 Z"
                    id="1"
                    fill="#171F66"
                ></path>
                <path
                    d="M181.548061,82.4447101 C181.77082,121.294502 182.084239,157.00697 182.733604,158.378288 C197.32925,161.180808 250.178837,159.841591 250.173924,159.233368 C250.146485,155.82544 250.313809,89.8671929 250.255778,82.6626568 L181.548061,82.4447101 Z"
                    id="Fill-38-Copy-2"
                    fill="#CAE4FE"
                ></path>
                <path
                    d="M246.492614,86.1991748 C245.737663,87.2805544 242.276702,90.4785136 242.238509,90.440218 C242.024557,90.2255565 238.603178,86.8853032 238.095181,86.3207256 L246.492614,86.1991748 Z"
                    id="Fill-41-Copy-2"
                    fill="#FFFFFF"
                ></path>
                <path
                    d="M229.915269,137.783262 C256.168429,116.049605 215.450887,83.0895354 197.629645,110.984832 C194.970076,115.147783 194.209008,119.177168 194.638395,123.608563 C195.999327,137.653264 212.073726,148.825987 229.722546,137.927903 L229.915269,137.783262 Z"
                    id="Fill-42-Copy-2"
                    fill="#4F8EF9"
                ></path>
                <path
                    d="M229.997355,104.971498 C236.547366,110.169085 241.263767,119.45763 237.282571,127.989839 C235.502913,127.647714 233.779338,127.136355 232.019425,126.735566 C229.940623,126.307839 214.112064,123.660284 213.99313,122.493491 C214.424186,121.270568 216.140994,119.580589 217.032955,118.605179 C218.113283,117.423837 219.469394,115.998173 220.533314,114.887978 C223.691054,111.592966 226.980149,108.382617 229.997355,104.971498 Z"
                    id="Fill-43-Copy-2"
                    fill="#FFC100"
                ></path>
                <path
                    d="M229.802383,104.788363 C231.593629,106.254575 231.018661,105.934293 231.765547,106.665005 C225.496418,111.514178 219.621793,117.074953 214.143768,122.703084 L213.99313,121.957541 C214.083327,119.368086 214.769309,104.899225 216.10688,100.278417 C221.363074,100.317182 225.771501,102.041127 229.802383,104.788363 Z"
                    id="Fill-44-Copy-2"
                    fill="#FF8100"
                ></path>
                <path
                    d="M250.257176,23.3351697 C250.132031,49.7485793 249.908345,74.028796 249.26241,74.9595278 C234.67418,76.8285003 181.822183,75.7860732 181.825613,75.3726128 C181.844524,73.0555449 181.511359,28.2101543 181.551406,23.311892 L250.257176,23.3351697 Z"
                    id="Fill-37-Copy-2"
                    fill="#FFFFFF"
                ></path>
                <path
                    d="M246.492614,27.0663567 C245.737663,28.1478302 242.276702,31.3457893 242.238509,31.3074938 C242.024557,31.0927384 238.603178,27.7524851 238.095181,27.1880013 L246.492614,27.0663567 Z"
                    id="Fill-52-Copy-2"
                    fill="#CAE4FE"
                ></path>
                <g transform="translate(9.908374, 23.311892)">
                    <path
                        d="M162.404992,52.2716401 C162.392292,25.918208 162.123925,1.69440214 160.608463,0.772587211 C126.175994,-0.937195987 1.34665145,0.664740214 1.35026675,1.07726202 C1.3701046,3.38897976 0.103263711,48.13835 0.144323659,53.025255 L162.404992,52.2716401 Z"
                        id="Fill-36-Copy-2"
                        fill="#FFFFFF"
                    ></path>
                    <path
                        d="M14.0493531,12.2182481 C20.834544,12.2456557 27.5680082,12.3602608 34.1726191,11.2633939"
                        id="Stroke-45-Copy-2"
                        stroke="#CAE4FE"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    ></path>
                    <path
                        d="M14.0493531,17.8366921 C46.9017465,17.762166 79.9196098,19.10786 112.757078,19.10786"
                        id="Stroke-46-Copy-2"
                        stroke="#CAE4FE"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    ></path>
                    <path
                        d="M14.0493531,25.6877338 C46.9017465,25.6132077 79.9196098,26.9589017 112.757078,26.9589017"
                        id="Stroke-46-Copy-2"
                        stroke="#CAE4FE"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    ></path>
                    <path
                        d="M14.0493531,33.5387755 C31.7759363,33.4642494 49.5918042,34.8099434 67.3103342,34.8099434"
                        id="Stroke-46-Copy-2"
                        stroke="#CAE4FE"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    ></path>
                    <path
                        d="M14.0493531,39.4218787 C37.4047968,40.3848051 60.6627199,40.3752312 84.0537604,40.375233"
                        id="Stroke-49-Copy-2"
                        stroke="#CAE4FE"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    ></path>
                    <path
                        d="M157.789073,5.63169696 C157.034122,6.7131705 153.57316,9.91112962 153.534968,9.87274022 C153.321016,9.6580787 149.899637,6.31782538 149.39164,5.75324775 L157.789073,5.63169696 Z"
                        id="Fill-53-Copy-2"
                        fill="#CAE4FE"
                    ></path>
                </g>
                <path
                    d="M172.316555,82.9600104 C172.207355,121.60556 171.850273,157.129272 170.331381,158.486511 C135.891682,161.118954 11.0646565,159.223606 11.069755,158.618668 C11.0981212,155.228668 9.99508161,89.6112322 10.0550586,82.4447101 L172.316555,82.9600104 Z"
                    id="Fill-39-Copy-2"
                    fill="#FFFFFF"
                ></path>
                <path
                    d="M49.3752941,146.349485 C49.5051189,137.775625 49.414934,103.385121 49.6429832,103.218798 C50.2159319,102.801154 63.1267788,102.544559 63.7827485,103.535147 C64.8643304,105.168499 65.0288602,141.418114 65.0288602,146.621098"
                    id="Fill-54-Copy-3"
                    fill="#4F8EF9"
                ></path>
                <path
                    d="M77.6969101,146.646175 C77.6969101,143.561686 77.4104148,127.424742 77.6422972,127.351022 C78.2246731,127.165796 91.3479546,127.052057 92.0147176,127.491275 C93.1140958,128.215465 93.2052791,144.114969 93.2052791,146.421965"
                    id="Fill-55-Copy-3"
                    fill="#FF8700"
                ></path>
                <path
                    d="M106.656007,146.646175 C106.656007,142.317219 106.369512,119.66967 106.601394,119.566206 C107.18377,119.306249 120.307052,119.146622 120.973815,119.763046 C122.073193,120.779417 122.164376,143.093729 122.164376,146.331506"
                    id="Fill-55-Copy-4"
                    fill="#FFC100"
                ></path>
                <path
                    d="M21.1767215,95.5853364 C22.1163307,101.743222 21.9440937,146.134416 22.9690798,147.155818 C117.350643,147.155818 148.923074,148.048817 156.181403,147.155818"
                    id="Stroke-21-Copy"
                    stroke="#CAE4FE"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                ></path>
                <path
                    d="M191.918976,33.6366698 C191.918976,36.4845477 191.527717,61.1727454 191.918976,67.5506338 C191.942521,67.9344475 233.981887,66.9057283 240.89899,66.9057283"
                    id="Stroke-50-Copy-2"
                    stroke="#CAE4FE"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                ></path>
                <ellipse
                    id="Oval-2"
                    fill="#4F8EF9"
                    cx="203.10502"
                    cy="50.6392191"
                    rx="2.73937407"
                    ry="2.7478646"
                ></ellipse>
                <ellipse
                    id="Oval-2-Copy"
                    fill="#FF8100"
                    cx="218.758586"
                    cy="41.217969"
                    rx="2.73937407"
                    ry="2.7478646"
                ></ellipse>
                <ellipse
                    id="Oval-2-Copy-2"
                    fill="#FFC100"
                    cx="232.846796"
                    cy="59.2753649"
                    rx="2.73937407"
                    ry="2.7478646"
                ></ellipse>
            </g>
        </svg>
    );
};
export default art;
